import * as Models from 'models';
import { getValueIn } from 'utils/getter';

export function isLayoutScrollable(layout: Models.LayoutMap | Models.Layout): boolean {
  return getValueIn(layout, ['styles', 'scrollable']);
}
